@if (!hasError) {
  <img class="advisor-image" [src]="'/advisorimage/' + portalId + path" [alt]="altText" [attr.aria-describedby]="ariaDescription" (error)="onError()">
}
